import { all, takeEvery, put, call, select } from 'redux-saga/effects'
import { REQUEST_ROOMS_LIST, REQUEST_CREATE_CHANNEL, REQUEST_DELETE_ROOM } from './constants'
import { setRoomsList, successCreateChannel } from './actions'
import RoomsClient from '../../apiClient/RoomsClient'
import { message } from 'antd'

const roomsClient = new RoomsClient()

function* getAll({ payload: { page, filter } }) {
    try {
        const { rooms, pagination } = yield call(roomsClient.getAll, page, filter)
        yield put(setRoomsList({ rooms, pagination }))
    } catch (e) {
        console.warn(e)
    }
}

function* requestCreateChannel({ payload: params }) {
    try {
        const { room } = yield call(roomsClient.postChannel, params)
        yield put(successCreateChannel())
        yield getAll({ payload: { page: 1, filter: '' } })
        message.success('Channel successfully created')
    } catch (e) {
        console.warn(e)
    }
}

function* deleteRoom({ payload: { roomId, filter } }) {
    try {
        const { roomDeleted } = yield call(roomsClient.deleteRoom, roomId)
        const page = yield select(({ rooms }) => rooms.pagination.page_number)
        yield getAll({ payload: { page, filter } })
    } catch (e) {
        console.warn(e)
    }
}

export default function* appSagas() {
    yield all([
        takeEvery(REQUEST_ROOMS_LIST, getAll),
        takeEvery(REQUEST_CREATE_CHANNEL, requestCreateChannel),
        takeEvery(REQUEST_DELETE_ROOM, deleteRoom)
    ])
}
